// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"styles_wrapper__hh7aQ","boton":"styles_boton__HG3ID","icono":"styles_icono__t1voj"};